"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormatMessage = useFormatMessage;
var _reactMintl = require("@godaddy/react-mintl");
function useFormatMessage(id, values = {}) {
  const {
    messages = {},
    formatMessage
  } = (0, _reactMintl.useIntl)();
  return messages[id] ? formatMessage({
    id
  }, values) : id;
}